<template>
  <div>
    <LoadingOverlay :loading="loading" />
    <div class="agencyCentre-wrapper">
      <div class="agencyCentre-topSec" :style="{ backgroundImage: `url(${agnecyCenterBg})` }">
        <div class="position-relative items-center agencyCentre-headerBar text-white">
          <div class="angle" id="close" @click="viewClose('someStatus')"></div>
          <div class="text-center agencyCentre-headerHD">Invite Agent</div>
          <div class="d-flex justify-content-center align-items-center text-center agencyCentre-dropdown"
            @click="goToAgencyTeamList">My Agent</div>
        </div>
        <div class="text-center text-white agencyCentre-topContentBox">
          <div class="mb-1">
            <img :src="invite_yourFrientTextImage" alt="invite" />
          </div>
          <p class="agencyCentre-topTitle mb-0">अपने दोस्त को एजेंट बनने का मौका दें!</p>
          <div class="agencyCentre-gapBG"></div>

          <div class="d-flex justify-content-center align-items-center gap-1 agencyCentre-IDBox" @click="copyAgencyId">
            <span>Invite ID :</span>
            <span>{{ agencyData?.agency_profile_id || '-' }}</span>
            <img :src="copyIdIcon" class="copyIcon" title="Copy ID" alt="Copy ID" />
          </div>

          <div class="cursor-pointer text-center text-white inviteYourFriend-buttonBox">
            <div class="inviteYourFriend-button" @click="sendInvite"
              :style="{ backgroundImage: `url(${invite_yourFrientBtnBg})` }">Invite Agent</div>
          </div>
        </div>

        <div class="agencyIncome-cardWrapper">
          <div class="agencyIncome-card">
            <div class="d-flex justify-content-between align-items-center agencyIncome-cardHeader">
              <div class="d-flex justify-content-center align-items-center gap-1 fw-semibold agencyIncome-card-title">
                Agency Income :
                <span class="agency-totalIncome yellow_text">
                  ${{ money(agencyData?.agency_total_commission) }}
                </span>
              </div>
              <div class="position-relative agencyIncome-card-dropdown acretIcon yellow_borderColor yellow_caretIcon"
                @click="openDateModal">
                {{ selectedWeek }}
              </div>
            </div>

            <div class="agencyIncome-cardBody">
              <div class="d-flex justify-content-between agencyIncome-cardBoxes subAgency-cardBoxes">
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Agent Income</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">${{ money(agencyData?.subagency_income) }}
                  </h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">My Commission</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">{{ agencyData?.commission_ratio ??
                    0 }}%</h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">My Income</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">${{ money(agencyData?.agency_total_commission) }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /topSec -->

      <div class="agencyIncome-cardWrapper hostCard-listWrapper mt-3">
        <div class="agencyIncome-card">
          <div class="d-flex justify-content-between align-items-center agencyIncome-cardHeader">
            <div class="fw-semibold agencyIncome-card-title">Agent Income Details</div>
            <div class="agencyIncome-card-title">
              <span class="agency-totalIncome yellow_text">${{ money(agencyData?.subagency_income) }}</span>
            </div>
          </div>
          <div class="agencyIncome-cardBody">
            <template v-if="agencyHostData && agencyHostData.length">
              <div class="hostCard-boxWrap" v-for="agencyHostInfo in agencyHostData"
                :key="agencyHostInfo?.user_id || agencyHostInfo?.id">
                <div class="d-flex justify-content-between align-items-center hostCard-topBoxes">
                  <div class="d-flex align-items-center hostCard-leftBox">
                    <div class="d-flex align-items-center hostCard-imageBox">
                      <img
                        :src="agencyHostInfo?.profile_image && agencyHostInfo.profile_image.length ? agencyHostInfo.profile_image : defaultProfile"
                        alt="host profile image" @error="onImageError" />
                    </div>
                    <div class="hostCard-infoBox">
                      <div class="hostCard-name">{{ agencyHostInfo?.name || '-' }}</div>
                      <div class="hostCard-ID">ID: {{ agencyHostInfo?.profile_id || '-' }}</div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center gap-2 hostCard-rightBox">
                    <!-- @click="goToTeamIncomeOverview(agencyHostInfo.user_id)" -->
                    <div>${{ money(agencyHostInfo?.commsion_amount_dollar) }}</div>
                    <!-- <img :src="blackNextArrow" class="blackNextArrow" alt=">" /> -->
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="text-center py-3">
              No Data Found
            </div>
          </div>
        </div>
      </div>

      <!-- Weekly Date popup -->
      <div class="dateSelectionModal" :style="showModal ? { bottom: '0' } : {}" v-if="showModal" @click="closeModal">
        <div class="dateSelectionModal-body" :style="{ bottom: '0' }" @click.stop>
          <div class="text-center dateSelection-HD">Select Date Range</div>
          <ul class="dateOptions-list">
            <li class="d-flex justify-content-center align-items-center gap-2 dateOptions-box"
              v-for="(range, index) in dateRanges" :key="index" @click="selectDate(range)">
              <div class="numberOf-week">{{ range.week_data }}</div>
              <div class="dateOptions">{{ range.start_date }}</div>
              <div class="dateOptions-to">to</div>
              <div class="dateOptions">{{ range.end_date }}</div>
            </li>
          </ul>
        </div>
      </div>

      <!-- copy id -->
      <div v-if="showCopyPopup" class="copy-popup">Invite URL Copied</div>
    </div>
  </div>
</template>

<script>
import { viewClose as androidViewClose } from '@/utils/android';
import axios from "axios";
import "../AgencyComponent/AgencyCentreStyle.css";

import agnecyCenterBg from "../../assets/images/agency-centre/agnecy-bg.webp";
import invite_yourFrientTextImage from "../../assets/images/agency-centre/become_an_agentText.webp";
import invite_yourFrientBtnBg from "../../assets/images/agency-centre/inviteFriend_btnBg.webp";
import defaultProfile from "../../assets/images/default_profile.webp";
import blackNextArrow from "../../assets/images/agency-centre/black-nextarrow.svg";
import copyIdIcon from "../../assets/images/agency-centre/copy_Id_icon.svg";
import beansIcon from "../../assets/images/beansIcon.png";

import LoadingOverlay from "../LoadingOverlay.vue";

// Base URL
const API_BASE =
  (import.meta?.env?.VITE_API_BASE_URL) ||
  (typeof process !== "undefined" && process.env?.VUE_APP_API_BASE_URL) ||
  "https://starmate.co.in/api";

export default {
  name: "InviteSubAgent",
  components: { LoadingOverlay },

  data() {
    return {
      // API data
      agencyData: {},
      agencyHostData: [],
      dateRanges: [],

      // UI state
      selectedWeek: "This Week",
      startDate: "",
      endDate: "",
      showModal: false,
      loading: false,
      showCopyPopup: false,

      // Auth
      authToken: "",

      // Assets
      agnecyCenterBg,
      invite_yourFrientTextImage,
      invite_yourFrientBtnBg,
      defaultProfile,
      blackNextArrow,
      copyIdIcon,
      beansIcon,

      // Invite landing base
      landingBase: "https://h5.starmate.co.in", // https://h5.starmate.co.in/
    };
  },

  computed: {
    // ✅ Invite URL that must be copied/shared
    localInviteUrl() {
      const id = this.agencyData?.agency_profile_id;
      return id ? `${this.landingBase}/become_agency/profile_id=${id}` : "";
    },
  },

  async mounted() {
    this.authToken = this.normalizeToken(
      this.$route.params.token || this.$route.query.token || ""
    );

    if (!this.authToken) {
      console.error("Token missing in URL. Expected /agency-centre/token=<JWT> or ?token=<JWT>");
      return;
    }

    // Create axios instance AFTER token is ready
    this.api = axios.create({
      baseURL: API_BASE,
      headers: { Authorization: `Bearer ${this.authToken}` },
    });

    // Optional debug
    // this.api.interceptors.request.use((cfg) => {
    //   console.log("[API]", cfg.method?.toUpperCase(), cfg.baseURL + "/" + cfg.url);
    //   return cfg;
    // });

    await this.initPage();
  },

  methods: {
    normalizeToken(input) {
      if (!input || typeof input !== "string") return "";
      return input.startsWith("token=") ? input.slice(6) : input;
    },

    money(val) {
      const num = Number(val);
      return Number.isFinite(num) ? num.toFixed(2) : "0.00";
    },

    async initPage() {
      this.loading = true;
      try {
        await this.fetchDateRanges(true); // sets default week
        await this.fetchAgencyData(false);
      } catch (err) {
        console.error("Init failed:", err);
      } finally {
        this.loading = false;
      }
    },

    async fetchDateRanges(setDefault = false) {
      const { data } = await this.api.get("getweeklistfromagency");

      if (!data?.success || !Array.isArray(data.result)) {
        this.dateRanges = [];
        return;
      }

      this.dateRanges = data.result;

      if (setDefault && this.dateRanges.length) {
        const first = this.dateRanges[0];
        this.startDate = first.start_date;
        this.endDate = first.end_date;
        this.selectedWeek = first.week_data;
      }
    },

    async fetchAgencyData(manageLoading = true) {
      if (manageLoading) this.loading = true;
      try {
        const { data } = await this.api.get("subagencycenterfromagency", {
          params: { start_date: this.startDate, end_date: this.endDate },
        });

        this.agencyData = data?.result?.agency_data || {};
        this.agencyHostData = data?.result?.data || [];
      } catch (err) {
        console.error("Failed to fetch agency data:", err);
      } finally {
        if (manageLoading) this.loading = false;
      }
    },

    async openDateModal() {
      try {
        await this.fetchDateRanges(false);
        this.showModal = true;
      } catch (err) {
        console.error("Failed to open date modal:", err);
      }
    },

    async selectDate(range) {
      this.selectedWeek = range.week_data;
      this.startDate = range.start_date;
      this.endDate = range.end_date;
      this.showModal = false;
      await this.fetchAgencyData(true);
    },

    closeModal() {
      this.showModal = false;
    },

    // ✅ invite uses your landing URL too (not only Play Store)
    sendInvite() {
      const inviteLink = this.localInviteUrl || "";
      const message =
        `*Become a Starmate Agent :*\n` +
        (inviteLink ? `${inviteLink}\n` : "");

      if (window.WhatsAppBridge?.invite) {
        window.WhatsAppBridge.invite(message);
        return;
      }

      window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message), "_blank");
    },

    async copyAgencyId() {
      const text = this.localInviteUrl;
      if (!text) return;

      const onSuccess = () => {
        this.showCopyPopup = true;
        setTimeout(() => (this.showCopyPopup = false), 2000);
      };

      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
          onSuccess();
          return;
        }
      } catch (e) {
        // ignore and fallback
      }

      this.fallbackCopyText(text, onSuccess);
    },

    fallbackCopyText(text, onSuccess) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      textarea.style.top = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        const ok = document.execCommand("copy");
        if (ok) onSuccess();
      } catch (err) {
        console.error("Fallback copy failed:", err);
      }

      document.body.removeChild(textarea);
    },

    goToAgencyTeamList() {
      const token = encodeURIComponent(this.authToken);
      this.$router.push(`/get-agent-list/token=${token}`);
    },

    // goToTeamIncomeOverview(userId) {
    //   const q = new URLSearchParams({
    //     userid: String(userId),
    //     start_date: this.startDate,
    //     end_date: this.endDate,
    //     token: this.authToken,
    //   }).toString();

    //   this.$router.push(`/transaction-history?${q}`);
    // },

    onImageError(event) {
      event.target.src = this.defaultProfile;
    },

    viewClose(status) {
      if (window.Android && typeof window.Android.viewClose === "function") {
        androidViewClose(status);
      } else {
        window.parent.postMessage({ action: "closePopup", status }, "*");
      }
    },
  },
};
</script>
